export enum PrintStatusEnum {
  LabelPrintComplete = "labelPrintComplete",
  LabelPrintError = "labelPrintError",
  EndFlow = "endFlow",
}

export const MailsLabelsBroadcastChannel = "MailsLabels";

export const labelPrinterTimeout = 30000;
